import { LOGIN, LOGOUT, UPDATE_CREDENTIAL, SIGNIN } from "../../data/constants";
// eslint-disable-next-line
export default (state, action) => {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        token: action.payload,
      };
    case SIGNIN:
      return {
        ...state,
        user: action.payload,
      };
    case LOGOUT:
      return {
        ...state,
        token: null,
      };
    case UPDATE_CREDENTIAL:
      return {
        ...state,
        credential: action.payload,
      };
    default:
      return state;
  }
};
